import { HGenerateFileData, IFileData } from "@rf-l1/file/helpers/create-file-data";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useUploadDocumentByIdMutation } from "@/src-refactor/modules/store/qrtk/services/realestate/realestate.qrtk";
import { CDocumentKeys } from "../util/model/documents-types";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import { onSendEventBlockerEnd, onSendEventBlockerStart } from "./useUploadingBlocker";

/**
 * Modo edición (no draft): sube documentos a /v3/admin/realestates/:id/documents
 * Eliminar: solo remueve del formulario, no llama API.
 */
const useManagerDocumentsEdit = () => {
  const { setValue, getValues } = useFormContext();
  const { id } = useParams();
  const realEstateId = Number(id);
  const [uploadDocument] = useUploadDocumentByIdMutation();

  const uploadDocumentEdit = async (
    data: IFileData,
    type: string | number,
    key: string
  ) => {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("data", data);
        // Solo bloquear si realmente subiremos un archivo
        if (!(data?.file instanceof File)) {
          resolve({ url: data?.url ?? "", id: data?.id?.toString?.() ?? "" });
          return;
        }

        onSendEventBlockerStart();

        const res = await uploadDocument({
          params: { id: realEstateId },
          body: {
            document: data.file as File,
            type
          }
        }).unwrap();

        const document = HGenerateFileData({
          file:
            (res as any)?.url ??
            (res as any)?.data?.filename ??
            (res as any)?.data?.path ??
            "",
          id: Number((res as any)?.id ?? (res as any)?.data?.id) ?? 0,
          comment: ""
        });

        const newArray = [...getValues(key)];
        const pos = newArray.findIndex((item: IFileData) => item.id === data.id);
        newArray.splice(pos, 1, document as IFileData);

        setValue(key, [...newArray]);

        // Si este documento fue marcado para eliminar, lo removemos de remove_documents
        try {
          const allow = Object.values(CDocumentKeys) as string[];
          if (allow.includes(String(type))) {
            const current = (getValues(
              CPropertyFormKeys.remove_documents
            ) || []) as string[];
            if (current.includes(String(type))) {
              setValue(
                CPropertyFormKeys.remove_documents,
                current.filter(t => t !== String(type))
              );
            }
          }
        } catch { }
        resolve({ url: document?.url ?? "", id: document?.id?.toString?.() ?? "" });
      } catch (err) {
        reject(err);
      } finally {
        onSendEventBlockerEnd();
      }
    });
  };

  const deleteDocumentEdit = (index: number, key: string, type?: string | number) => {
    return new Promise<void>((resolve, reject) => {
      try {
        const fields = getValues(key) as IFileData[];
        setValue(
          key,
          fields.filter((_, i) => i !== index)
        );

        // Marcar el documento para eliminar en el guardado (solo claves de CDocumentKeys)
        try {
          if (typeof type !== "undefined") {
            const allow = Object.values(CDocumentKeys) as string[];
            // if (allow.includes(String(type))) {
            const current = (getValues(
              CPropertyFormKeys.remove_documents
            ) || []) as string[];
            if (!current.includes(String(type))) {
              setValue(CPropertyFormKeys.remove_documents, [
                ...current,
                String(type)
              ]);
            }
            // }
          }
        } catch { }
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  };

  return {
    uploadDocumentEdit,
    deleteDocumentEdit
  };
};

export default useManagerDocumentsEdit;
